'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { CourseDetail } from '@eliadmin/core/src/api/courses/coursers-api';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useDialogStore } from '@eliadmin/core/src/components/ui/dialog';
import { SignInDialog } from "@eliadmin/core/src/components/dialog/lazy-dialogs";

type CourseDetailPublicProps = {
  course: CourseDetail;
};

export function CourseDetailPublic({ course }: CourseDetailPublicProps) {
  const { t } = useTranslations();

  const openDialog = useDialogStore(s => s.open);

  const handleSignInClick = () => {
    openDialog({
      id: SignInDialog.id,
      content: <SignInDialog />,
    });
  };

  return (
    <>
      <section
        className={cn('custom-section', 'relative flex h-[85vh] items-center justify-center')}
      >
        <div className="relative z-[3] mx-auto flex w-full max-w-[1024px] flex-col items-center justify-center gap-4">
          <h1 className="text-balance text-center font-heading text-2xl font-medium text-white sm:text-3xl md:text-4xl lg:text-6xl">
            {course?.name}
          </h1>
          <p className="text-center text-sm leading-relaxed text-white sm:text-base lg:text-lg lg:leading-relaxed">
            {t('text2257')}{' '}
            <Link
              prefetch={false}
              href={ROUTES.SUBSCRIPTION()}
              className="font-medium text-primary"
            >
              {t('text2258')}
            </Link>
            <br />
            {t('text2259')}{' '}
            <button
              type="button"
              onClick={handleSignInClick}
              className="inline cursor-pointer bg-transparent p-0 font-medium text-primary"
            >
              {t('text2260')}
            </button>
          </p>
        </div>
        <div className="absolute inset-0 z-[1] h-full w-full bg-black/50 backdrop-blur-sm" />
        <Image
          src={course?.image?.url ?? '/images/placeholder.png'}
          alt={resolveImageAlt(course?.image, course?.name)}
          width={0}
          height={0}
          className="absolute inset-0 z-0 h-full w-full object-cover"
          sizes="100vw"
          priority
        />
      </section>
    </>
  );
}
